import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 54px;
  background: #FFF;
  border-bottom: 1px solid #e8e8e8;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: bold;
  position: relative;
  cursor: pointer;
  &:hover {
    background: #DDD;
  }
`;

const BackIcon = styled.i`
  position: absolute;
  left: 16px;
`;

@observer
class MobileSettingsHeader extends React.Component {

  render() {
    return (
      <Wrapper
        onClick={this.props.onBack}
      >
        <BackIcon className='fa fa-chevron-left' />
        {this.props.title}
      </Wrapper>
    );
  }
}

export default MobileSettingsHeader;
